import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "nextButton"]
  static values = { checkInPath: String }

  connect() {
    this.selected = new Set()
  }

  toggle(event) {
    const card = event.currentTarget
    const id = card.dataset.instanceId
    if (!id) return
    const selected = !this.selected.has(id)
    if (selected) {
      this.selected.add(id)
    } else {
      this.selected.delete(id)
    }
    const value = selected ? "true" : "false"
    card.dataset.selected = value
    const indicator = card.querySelector("[data-check-indicator]")
    if (indicator) indicator.dataset.selected = value
    const icon = card.querySelector("[data-check-icon]")
    if (icon) icon.classList.toggle("hidden", !selected)
    this.updateNextButton()
  }

  updateNextButton() {
    const n = this.selected.size
    const btn = this.nextButtonTarget
    btn.disabled = n === 0
    const label = btn?.querySelector(".next-label")
    if (label) label.textContent = n > 0 ? `Next (${n})` : "Next"
  }

  goNext() {
    const ids = Array.from(this.selected)
    if (ids.length === 0) return
    const params = ids.map((id) => `instance_ids[]=${encodeURIComponent(id)}`).join("&")
    window.location.href = `${this.checkInPathValue}?${params}`
  }
}
